import axios from 'axios';
import { AUTH_BEARER_TOKEN_KEY } from 'src/constants';
import { getLocalStorageItem } from 'src/hooks/useLocalStorage';
import { getApiUrl } from 'src/utils/env';

const axiosInstanceBaseAuth = axios.create({
  baseURL: getApiUrl()
});

axiosInstanceBaseAuth.interceptors.request.use(
  config => {
    const token = getLocalStorageItem<string>(AUTH_BEARER_TOKEN_KEY);

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axiosInstanceBaseAuth;
